import { Currency } from '../General/Currency';
import { PaymentMethod } from '../General/PaymentMethod';

export enum SERVICE_ORDER_STATUS {
  PENDIENTE_DE_COORDINACION = 0,
  COORDINADA = 1,
  REALIZADA = 2,
  PENDIENTE_DE_FACTURACION = 3,
  FINALIZADA = 4,
  CANCELADO = 5,
}

export const ServiceOrderStatusString = {
  [SERVICE_ORDER_STATUS.PENDIENTE_DE_COORDINACION]: 'Pendiente de coordinación',
  [SERVICE_ORDER_STATUS.COORDINADA]: 'Coordinada',
  [SERVICE_ORDER_STATUS.REALIZADA]: 'Realizada',
  [SERVICE_ORDER_STATUS.PENDIENTE_DE_FACTURACION]: 'Pendiente de facturación',
  [SERVICE_ORDER_STATUS.FINALIZADA]: 'Finalizada',
  [SERVICE_ORDER_STATUS.CANCELADO]: 'Cancelada',
};

export enum SERVICE_ORDER_TYPE {
  INSTALACION = 0,
  SERVICIO_TECNICO = 1,
}
export const ServiceOrderTypeString = {
  [SERVICE_ORDER_TYPE.INSTALACION]: 'Instalación de OV cerrada',
  [SERVICE_ORDER_TYPE.SERVICIO_TECNICO]: 'Servicio Técnico',
};

export interface ServiceOrder {
  id: number;
  service_date: string;
  description: string;
  company: number;
  technician: number;
  moviles?: number[];
  contact_data?: string;
  aditional_comment?: string;
  status: SERVICE_ORDER_STATUS;
  type: SERVICE_ORDER_TYPE;
  kilometres_estimated?: number;
  hours_estimated?: number;
  technician_pay: boolean;
  customer_invoice: boolean;
  hours_covered?: number;
  kilometres_covered?: number;
  billing_order?: number;
  tickets?: number[];
  kilometres?: number;
  hours?: number;
  kilometres_to_pay?: number;
  hours_to_pay?: number;
  odoo_purchase_order?: number;
  created_at: string;
  updated_at: string;
  created_by?: number;
  hourly_rate?: number;
  kilometres_rate?: number;
  currency?: Currency;
  created_automatically?: boolean;
  delivery_note_links?: string[];
  billing_numbers?: string;
  payment_method?: PaymentMethod;

  // Atributos del response de edición
  receptions_created?: number[];

  //
  stock_technician_reviewed?: boolean;
}
